import { AuthenticatedUserActions } from '@/app/platform/platform-core/user/store/types';
import { Inject, Injectable } from '@angular/core';
import { AsyncResult } from '@common/result/asyncResult';
import { UserStore } from '@/app/platform/platform-core/user/store/user.store';
import {
  AUTHENTICATION_SERVICE,
  AuthenticationService
} from '@/app/platform/platform-core/user/services/types';
import { USER_ACTIVATOR, UserActivator } from '@/app/platform/platform-core/user/activators/types';

@Injectable({
  providedIn: 'root'
})
export class AuthenticatedUserStoreActions implements AuthenticatedUserActions {
  constructor(
    private readonly userStore: UserStore,
    @Inject(AUTHENTICATION_SERVICE)
    private readonly authService: AuthenticationService,
    @Inject(USER_ACTIVATOR)
    private readonly userActivator: UserActivator
  ) {}

  async desktopLogout(): AsyncResult<boolean> {
    const result = await this.authService.logout();
    this.userActivator.deactivate();
    return result;
  }
}
